import Munio from "@vhiweb/munio-client-js";
import CryptoJS from "crypto-js";
import config from "./config";
import { getSessionForLoginUser } from "./utils/cookie";
import type { Cookies } from "@sveltejs/kit";

export class MunioClient extends Munio {
    async initMunio(url: string, serverCookies?: Cookies) {
        const AES_SECRET_KEY: string = config.AES_SECRET_KEY || "";
        const AES_SECRET_IV: string = config.AES_SECRET_IV || "";

        const currentDomainUrl =
            import.meta.env.VITE_NODE_ENV === "development"
                ? config.CLIENT_URL
                : url;

        const keyBytes = CryptoJS.enc.Hex.parse(AES_SECRET_KEY);
        const ivBytes = CryptoJS.enc.Hex.parse(AES_SECRET_IV);

        const encryptedData = CryptoJS.AES.encrypt(
            currentDomainUrl?.toString() || "",
            keyBytes,
            {
                iv: ivBytes,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.ZeroPadding,
            },
        ).toString();

        this.init({
            host: config.BASE_URL,
            client: encryptedData,
            AppKey: getSessionForLoginUser() || "",
        });
    }
}

export const MUNIO = new MunioClient();
